// extracted by mini-css-extract-plugin
export var meganav = "nav-module--meganav--12TiY";
export var categoryItem = "nav-module--category-item--3wXM2";